"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FinancialCalculator = void 0;
const FinancialCalculator = (country, price, cost, partner) => {
  let maxLoanRatio = country === 'pt' ? 90 : 85;
  let maxAffordability = 33;
  if (price > 0) {
    const {
      equityCapital = 0,
      income = 0
    } = cost;
    let loanToValueRatio = -1;
    let affordability = -1;
    let affordabilityPerc = -1;
    let loanToValuePerc = -1;
    if (partner === 'baloise') {
      // Values needed
      maxLoanRatio = 80;
      maxAffordability = 38;
      // Percentages for mortgages
      const firstMortgage = 66;
      const loanValue = price - equityCapital;
      // Loan to value ratio calc
      loanToValueRatio = loanValue / price;
      loanToValuePerc = loanToValueRatio * 100 > 100 ? 100 : loanToValueRatio * 100;
      if (loanToValuePerc <= firstMortgage) {
        affordability = (loanValue * 0.05 + price * 0.0075) / income;
      } else {
        affordability = (loanValue * 0.05 + price * 0.0075 + (loanValue - price * (2 / 3)) / 15) / income;
      }
      affordabilityPerc = affordability * 100 > 100 ? 100 : affordability * 100;
    } else if (country.toLowerCase() === 'ch') {
      // Values needed
      // Percentages for mortgages
      const firstMortgage = 66;
      const loanValue = price - equityCapital;
      // Loan to value ratio calc
      loanToValueRatio = loanValue / price;
      loanToValuePerc = loanToValueRatio * 100 > 100 ? 100 : loanToValueRatio * 100;
      if (loanToValuePerc <= firstMortgage) {
        affordability = (loanValue * 0.05 + price * 0.01) / income;
      } else {
        affordability = (loanValue * 0.05 + price * 0.01 + (loanValue - price * (2 / 3)) / 15) / income;
      }
      affordabilityPerc = affordability * 100 > 100 ? 100 : affordability * 100;
      if (income < 125000 && affordabilityPerc > 33) {
        maxLoanRatio = 80;
        maxAffordability = 35;
      } else if (income < 125000) {
        maxAffordability = 33;
      } else if (income <= 175000) {
        maxAffordability = 36;
      } else {
        maxAffordability = 40;
      }
    }
    const roundLoan = +loanToValuePerc.toFixed(2);
    const roundAffordability = +affordabilityPerc.toFixed(2);
    loanToValuePerc = roundLoan % 1 !== 0 ? roundLoan : Math.round(loanToValuePerc);
    affordabilityPerc = roundAffordability % 1 !== 0 ? roundAffordability : Math.round(affordabilityPerc);
    return {
      loanToValueRatio: loanToValuePerc < 0 ? 0 : loanToValuePerc,
      affordability: affordabilityPerc < 0 ? 0 : affordabilityPerc,
      maxLoanRatio,
      maxAffordability,
      affordabilityCheck: affordabilityPerc < maxAffordability,
      loanToValueCheck: loanToValuePerc < maxLoanRatio
    };
  }
  return {
    loanToValueRatio: 100,
    affordability: 100,
    maxLoanRatio,
    maxAffordability,
    affordabilityCheck: false,
    loanToValueCheck: false
  };
};
exports.FinancialCalculator = FinancialCalculator;